import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import Logo from "../../assets/logo.svg";
import { IoIosMenu } from "react-icons/io";
import { IoMdClose } from "react-icons/io";
import {
  Container,
  SubContainer,
  NavItem,
  NavWrapper,
  BurgerNav,
  CustomClose,
  BurgerLogo,
} from "./Nav.styles";

const Nav = () => {
  const [burgerStatus, setBurgerStatus] = useState(false);
  return (
    <div>
      <SubContainer>
        <Container>
          <NavWrapper>
            <div>
              <Link to="/">
                <img src={Logo} alt="company_logo" />
              </Link>
            </div>
            <NavItem>
              <NavLink to="/">Home</NavLink>
              <NavLink to="/about">About Us</NavLink>
              <NavLink to="/product">Our Products</NavLink>
              {/* <NavLink to="/media">Media</NavLink> */}
              <NavLink to="/contact">Contact</NavLink>
            </NavItem>
            <div className="menu__icon" onClick={() => setBurgerStatus(true)}>
              <IoIosMenu size={40} />
            </div>
            <BurgerNav show={burgerStatus}>
              <CustomClose >
                
                <IoMdClose size={30} onClick={() => setBurgerStatus(false)} />
              </CustomClose>
              <div>
                <BurgerLogo>
                  <Link to="/">
                    <img src={Logo} alt="company_logo" />
                  </Link>
                </BurgerLogo>
                <NavLink to="/">Home</NavLink>
                <NavLink to="/about">About Us</NavLink>
                <NavLink to="/product">Our Products</NavLink>
                <NavLink to="/contact">Contact</NavLink>
              </div>
            </BurgerNav>
          </NavWrapper>
        </Container>
      </SubContainer>
    </div>
  );
};

export default Nav;
